import { type MouseEvent } from 'react';
import { Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface CopyAddressButtonProps {
  address: string;
  ariaLabel?: string;
  className?: string;
}

export function CopyAddressButton({
  address,
  ariaLabel = 'Copy address',
  className,
}: CopyAddressButtonProps) {
  const handleCopy = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(address);
    } catch (error) {
      console.error('Failed to copy address:', error);
    }
  };

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={handleCopy}
      aria-label={ariaLabel}
      title="Copy address"
      className={cn(
        'h-5 w-5 rounded-md p-0 text-muted-foreground hover:text-foreground',
        className
      )}
    >
      <Copy className="size-3.5" />
    </Button>
  );
}
